import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const FillInformationSkeleton = () => {
  return (
    <Box gap="s16">
      <Skeleton width="s400" height="s24" />
      <Box gap="s16" flexDirection="row">
        <Skeleton width="s200" height="s24" />
        <Skeleton width="s200" height="s24" />
      </Box>
      <Skeleton width="s400" height="s24" />
      <Skeleton width="s400" height="s24" />
      <Box gap="s16" flexDirection="row">
        <Skeleton width="s200" height="s24" />
        <Skeleton width="s200" height="s24" />
      </Box>
    </Box>
  )
}
